import { CommissionAdminGuard } from '@aid/accounting/guards/commission-admin.guard';
import { AccountingFeatureGuard } from '@aid/accounting/guards/accounting-feature.guard';

export const guards = [CommissionAdminGuard, AccountingFeatureGuard];

export * from './commission-admin.guard';
export * from './accounting-feature.guard';
